export const localStorageService = {
    /**
     * 指定されたキーに対して、値をJSON形式でローカルストレージに保存。
     * @param key - 保存するデータのキー
     * @param value - 保存するデータの値
     */
    setItem(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    /**
     * 指定されたキーからローカルストレージのデータを取得。
     * @param key - 取得するデータのキー
     * @returns 取得したデータ。存在しない場合はnullを返す。
     */
    getItem(key: string) {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null; // 取得したデータをJSON形式でパースして返す
    },
    /**
     * 指定されたキーに対応するデータをローカルストレージから削除。
     * @param key - 削除するデータのキー
     */
    removeItem(key: string) {
        localStorage.removeItem(key);
    },
    /**
     * 学習中断データをローカルストレージに保存。
     * @param value - 保存する学習中断データ
     */
    saveStudyBreakData(value: any) {
        this.setItem("study_break_data", value);
    },

    /**
     * 学習中断データをローカルストレージから取得。
     * @returns 取得した学習中断データ
     */
    loadStudyBreakData() {
        return this.getItem("study_break_data");
    },

    /**
     * 学習中断データをローカルストレージから削除。
     */
    deleteStudyBreakData() {
        this.removeItem("study_break_data");
    }
};